<template>
    <section class="vehicleCardFreeItemWrapperComponent">
      <div class="free-car-item-wrapper d-flex flex-wrap g-footer" v-if="!showItemText">

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus" :data-bs-content="$t('free_wifi')">
              <div class="image-parent">
                <img src="/assets/images/wifi-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                  :data-bs-content="$t('audio_equipment')">
              <div class="image-parent">
                <img src="/assets/images/headphones-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                  :data-bs-content="$t('microphone')">
              <div class="image-parent">
                <img src="/assets/images/mic-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                  :data-bs-content="$t('multimedia')">
              <div class="image-parent">
                <img src="/assets/images/youtube-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                  :data-bs-content="$t('electrical_connection')">
              <div class="image-parent">
                <img src="/assets/images/zap-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>

        <VehicleCardFreeItemComponent>
          <template #freeItem>
            <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                  :data-bs-content="$t('conditioner')">
              <div class="image-parent">
                <img src="/assets/images/conditioner-1.png" alt="" srcset="">
              </div>
            </span>
          </template>
        </VehicleCardFreeItemComponent>
      </div>

      <div class="parent-items-container align-content-end gap-1 gap-sm-1" v-else-if="showItemText">
    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('free_wifi')">
          <div class="image-parent">
            <img src="/assets/images/wifi-1.png" alt="" srcset="">
          </div>
          </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('free_wifi') }}</div>
    </div>

    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('audio_equipment')">
          <div class="image-parent">
            <img src="/assets/images/headphones-1.png" alt="" srcset="">
          </div>
          </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('audio_equipment') }}</div>
    </div>

    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('microphone')">
            <div class="image-parent">
            <img src="/assets/images/mic-1.png" alt="" srcset="">
          </div>
          </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('microphone') }}</div>
    </div>

    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('multimedia')">
          <div class="image-parent">
            <img src="/assets/images/youtube-1.png" alt="" srcset="">
          </div>
          </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('multimedia') }}</div>
    </div>

    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('electrical_connection')">
          <div class="image-parent">
            <img src="/assets/images/zap-1.png" alt="" srcset="">
          </div>
            </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('electrical_connection') }}</div>
    </div>

    <div class="d-flex align-items-center p-lg-1 p-xl-3">
      <VehicleCardFreeItemComponent>
        <template #freeItem>
          <span id="example" class="d-inline-block" tabindex="0" data-bs-toggle="popover" data-bs-trigger="hover focus"
                :data-bs-content="$t('conditioner')">
          <div class="image-parent">
            <img src="/assets/images/conditioner-1.png" alt="" srcset="">
          </div>
          </span>
        </template>
      </VehicleCardFreeItemComponent>
      <div class="ps-md-2 ps-4 free-car-item-text">{{ $t('conditioner') }}</div>
    </div>
    <div>
    </div>


  </div>
    </section>
</template>

<script lang="ts">
import './vehicleCardFreeItemWrapper.scss';

import {defineComponent} from "vue";

// @ts-ignore
import VehicleCardFreeItemComponent from "../vehicleCardFreeItem/VehicleCardFreeItemComponent";

import { Popover } from 'bootstrap/dist/js/bootstrap.esm.min.js';

export default defineComponent({
  name: 'VehicleCardFreeItemWrapperComponent',
  components: {
    VehicleCardFreeItemComponent
  },
  props: {
    showItemText: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {}
  },
  mounted() {
    let options = {
      customClass: 'custom-popover-class',
      html: true,
      placement: 'top',
      offset: [0,10]
    }

    document.querySelectorAll('.vehicleCardFreeItemWrapperComponent [data-bs-toggle="popover"]:not(.initialized)').forEach(elm => {
        new Popover(elm, options);
        elm.classList.add('initialized');
    });
  }
});
</script>